import { alpha } from '@mui/material/styles';

function Dialog(theme: any): any {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: alpha('#000', 0.7)
          },
          '& .MuiCardContent-root': {
            [theme.breakpoints.down('sm')]: {
              paddingBottom: `${theme.spacing(2.5)}`
            }
          },
          '& .MuiPaper-root:has(.tabbed-form)': {
            overflowY: 'unset',
            width: '100%'
          }
        }
      }
    }
  };
}

export { Dialog };
